import apiClient from '../clienteFebosAPI';

const RESOURCE = '/usuarios';

/**
 * Login contra la API.
 * Paso A (2FA de dos pasos): sin otp/desafioId => body vacio.
 * Paso B: se envia { otp, desafioId } para validar el codigo.
 *
 * Se marca seOmiteErrorReport para que el interceptor NO lance ante codigo != 10:
 * asi la capa superior puede detectar codigo == 11 (REQUIERE_2FA) como un estado
 * valido del flujo en lugar de un error.
 */
export const ioUserLogin = (email, password, { otp, desafioId } = {}) => {
  const body = {};
  if (otp) {
    body.otp = `${otp}`.trim();
  }
  if (desafioId) {
    body.desafioId = desafioId;
  }

  return apiClient.post(
    `${RESOURCE}/login`,
    body,
    {
      operacionId: 'io.usuario.login',
      seOmiteErrorReport: true,
      headers: {
        Authorization: `Basic ${ btoa(`${email}:${password}`)}`
      }

    }
  );
};

export const ioUserHeartbeat = (userId) => (
  apiClient.head(
    `${RESOURCE}/${userId}`,
    { operacionId: 'io.usuario.latido' }
  )
);

export const isUserUpdate = (id, iut, name, alias, email, avatar, cargo, departamento) => (
  apiClient.put(
    `${RESOURCE}/${id}?usuarioId=${id}`,
    {
      id,
      iut,
      alias,
      nombre: name,
      correo: email,
      avatar,
      cargo,
      departamento
    },
    { operacionId: 'io.usuario.actualizar', permiso: 'ADM09' }
  )
);

export const ioUpdateUser = (params, user) => {
  const paramsRequest = apiClient.queryParams(params);
  return apiClient.put(`${RESOURCE}/${user.id}?${paramsRequest}`,
    user, { operacionId: 'io.update.user' });
};
export const ioCopyRolesByUser = (payload) => {
  const paramsRequest = apiClient.queryParams(payload.params);

  return apiClient.post(`${RESOURCE}/roles?${paramsRequest}`,
    payload.body, { operacionId: 'io.copy.roles.user' });
};

export const ioCreateUser = (params, user) => {
  const paramsRequest = apiClient.queryParams(params);
  return apiClient.put(`${RESOURCE}?${paramsRequest}`,
    user, { operacionId: 'io.create.user' });
};

export const ioRemoveUser = (user) => {
  const params = apiClient.queryParams(user);
  return apiClient.delete(`${RESOURCE}/${user.usuarioId}?${params}`,
    { operacionId: 'io.remove.user' });
};

export const getUsers = (payload) => {
  const params = apiClient.queryParamsComponent(payload);

  return apiClient.get(`${RESOURCE}?${params}`, {
    operacionId: 'io.usuarios.listar'
  });
};

export const getUserById = (userId) => (
  apiClient.get(`${RESOURCE}/${userId}`,
    { operacionId: 'io.usuario.obtener' })
);

export const ioGetAuthCode = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.get(`${RESOURCE}/autenticadoble?${params}`, {
    operacionId: 'io.user.authCode'
  });
};

export const ioGetFileCode = (identification) => apiClient.post(`${RESOURCE}/autenticadoble`,
  identification, {
    operacionId: 'io.user.FileCode'
  });

export const getSharedFile = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.get(`${RESOURCE}/autenticadoble/${payload.id}?${params}`, {
    operacionId: 'io.user.sharedFile'
  });
};

export const updatePassword = (passwords) => {
  const params = apiClient.queryParams({
    simular: 'no'
  });
  return apiClient.put(`${RESOURCE}/login/recuperar?${params}`,
    passwords, { operacionId: 'io.usuario.update.password' });
};
export const forgotPassword = (userInfo) => {
  apiClient.post(`${RESOURCE}/login/recuperar?`, userInfo,
    {
      operacionId: 'io.usuario.forgot.password',
      permiso: 'USR02',
      params: { dominioPortal: window.location.hostname.toLocaleLowerCase() }
    });
};

export const getRoles = (payload) => apiClient.get(`${RESOURCE}/${payload.userId}/roles`, {
  operacionId: 'listar_roles_usuario'
});

export const modifyUserRoles = (payload) => apiClient.post(
  `${RESOURCE}/${payload.userId}/roles`,
  { roles: payload.assignedRoles },
  { operacionId: 'modificar_roles_usuario' }
);

export const sentOtpToVerify = (otp, user) => {
  const params = apiClient.queryParams({
    otp
  });
  return apiClient.get(`${RESOURCE}/${user.id}/2fa?${params}`,
    { operacionId: 'io.usuario.otp.veryfy' });
};

export const requestNewOtp = (user) => {
  const params = apiClient.queryParams({});
  return apiClient.put(`${RESOURCE}/${user.id}/2fa?${params}`, {},
    { operacionId: 'io.usuario.otp.new' });
};

export const getUserSign = (
  type = 'firmaSimple|firmaAvanzada',
  provider = '',
  ambit = 'perfil|unidad',
  userId
) => {
  const params = apiClient.queryParams({
    tipoFirma: type,
    proveedor: provider,
    idUsuarioFirma: userId,
    categoria: ambit,
    ambito: ambit
  });
  return apiClient.get(`${RESOURCE}/firma?${params}`,
    { operacionId: 'io.usuario.get.sign.config' });
};
export const configureSimpleAndEsign7Sign = (payload =
{
  categoria: '',
  codigo: '00000',
  idUsuarioFirma: '',
  parametros: {},
  proveedor: '',
  tipoFirma: ''
}) => {
  const params = apiClient.queryParams({});
  return apiClient.put(`${RESOURCE}/firma?${params}`, payload,
    { operacionId: 'io.usuario.put.sign.config' });
};

export const configureAdvancedSign = (payload) => {
  const params = apiClient.queryParams({});
  return apiClient.put(`${RESOURCE}/firma?${params}`, payload,
    { operacionId: 'io.usuario.put.sign.config' });
};

export const cuVerificationInfo = (userData) => {
  const params = apiClient.queryParams(userData.params);
  return apiClient.post(`${RESOURCE}/firma/enrrolamiento?${params}`, userData.body,
    { operacionId: 'io.usuario.cu.verification.info' });
};

export const cuEsignCertified = (userData) => {
  const params = apiClient.queryParams(userData.params);
  return apiClient.put(`${RESOURCE}/firma/enrrolamiento?${params}`, userData.body,
    { operacionId: 'io.usuario.cu.certified.info' });
};

export const signConfigStamp = (userData) => {
  const params = apiClient.queryParams(userData);
  return apiClient.put(`${RESOURCE}/firma?${params}`, userData,
    { operacionId: 'io.usuario.configure.sign' });
};

export const ioGetProcessInfo = (codeProcess) => apiClient.get(
  `${RESOURCE}/sso/autorize/${codeProcess}`, {
    operacionId: 'io.user.getInfoProcess'
  }
);
